/* eslint-disable @next/next/no-img-element */
import {useEffect, useRef, useState} from "react";
import {toast} from 'react-toastify';
import {getCookie} from "framework/libs/cookie";
import {TOKEN_CONGDONG, TOKEN_SHOP} from "framework/store/constants";
import http from 'utilities/http';
import {useForm} from "react-hook-form";
import {API_URL_V2} from "utilities/constants";
import {useRouter} from "next/router";
import Select from 'react-select';
import {isEmpty} from "lodash";
import {Button, Modal} from "react-bootstrap";
import Image from "next/image";

export default function HoSo({user, fetchData, xaPhuong , setIsProfessional}) {
    const [userTemp, setUserTemp] = useState({});
    const [avatarTemp, setAvatarTemp] = useState('');
    const [displayButtonAva, setDisplayButtonAva] = useState(false);
    const router = useRouter();

    const [tinh, setTinh] = useState(null);
    const [quan, setQuan] = useState(null);
    const [xa, setXa] = useState(null);
    const [avatar, setAvatar] = useState(null);

    useEffect(() => {
        if (isEmpty(user)) return;
        setUserTemp(user);
        setAvatarTemp(user.avatar);

    }, [user]);

    useEffect(() => {
        if (!isEmpty(xaPhuong)) {
            console.log(user.province);
            const tinhTemp = xaPhuong.find(x => x.id == user.province?.id);
            const quanTemp = tinhTemp?.districts?.data.find(x => x.id == user.district?.id);
            const xaTemp = quanTemp?.wards?.data.find(x => x.id == user.ward?.id);

            setTinh(tinhTemp);
            setQuan(quanTemp);
            setXa(xaTemp);
        }
    }, [xaPhuong, user]);

    const updateUser = async () => {
        try {
            const res = await http('user/update-profile', {}, {
                body: {
                    birthday: userTemp.birthday,
                    fullname: userTemp.fullname,
                    bio: userTemp.bio,
                    address: userTemp.address,
                    phone_number: userTemp.phone_number,
                    gender_id: userTemp.gender_id,
                    province_id: tinh?.id || null,
                    district_id: quan?.id || null,
                    ward_id: xa?.id || null,
                    // province_id: "",
                    // district_id: "",
                    // ward_id: "",
                    website: state.website,
                    facebook:state.facebook,
                    instagram :state.instagram,
                    youtube : state.youtube,
                    flickr : state.flickr,
                    cmnd_number: userTemp.cmnd_number,
                },
                method: 'POST',
                token: 'Bearer ' + getCookie(TOKEN_CONGDONG)
            }, 'v2');
            if (res.code === 200) {
                fetchData();
                setUserTemp(res.data);
                toast.info('Lưu thay đổi thành công!');
            } else {
                toast.error(res.errors);
            }
            // router.push('/tai-khoan/cai-dat');
        } catch (e) {
            console.log(e);
            toast.error('Đã xảy ra lỗi!');
        }
    };

    const {register, handleSubmit, setValue, getValues} = useForm();
    const onSubmit = async (data) => {
        const formData = new FormData();
        formData.append('avatar', avatar);
        try {
            const res = await fetch(API_URL_V2 + 'user/update-profile-picture', {
                body: formData,
                method: 'POST',
                headers: new Headers({
                    'Authorization': 'Bearer ' + getCookie(TOKEN_CONGDONG)
                })
            });
            if (res.ok) {
                setUserTemp({...userTemp, avatar: avatarTemp});
                toast.info('Đổi ảnh đại diện thành công');
                setDisplayButtonAva(false);
                // router.push('/tai-khoan/cai-dat');
            } else {
                toast.error('Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        } catch (e) {
            toast.error('Đã có lỗi xảy ra');
        }
    };

    const changeAvatar = (e) => {
        e.preventDefault();
        if (e.target.files.length !== 0) {
            let reader = new FileReader();
            reader.onloadend = () => {
                setAvatar(e.target.files[0]);
                setAvatarTemp(reader.result);
            };
            setDisplayButtonAva(true);
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    const deleteAvatar = () => {
        setAvatarTemp(user.avatar);
        setDisplayButtonAva(false);
    };

    const tinhOp = xaPhuong.map(x => ({value: x.id, label: x.name}));
    const quanOp = !isEmpty(tinh) ? tinh.districts.data.map(x => ({value: x.id, label: x.name})) : [];
    const xaOp = !isEmpty(quan) ? quan.wards.data.map(x => ({value: x.id, label: x.name})) : [];
    const customStyles = {
        control: (base) => ({
            ...base,
            color: 'black',
            cursor: 'pointer',
            paddingLeft: '5px',
        }),
        valueContainer: (base) => ({
            ...base,
            // maxHeight: '64px',
            // 'overflow-y': 'scroll'
        }),
        option: (base) => ({
            ...base,
            cursor: 'pointer',
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            color: 'black',
        }),
        indicatorSeparator: (base) => ({
            ...base,
            display: 'none'
        })
    };

    const [state, _setState] = useState({
        current : "",
        contentTempt : "" ,
        modalLink : false,
        website:"",
        facebook:"",
        instagram :"",
        youtube : "",
        flickr : ""
    });
    useEffect( ()=>{
        setState({
            website:(user?.links?.website != null && user.links?.website != "null" ) ? user.links?.website : "",
            facebook:(user?.links?.facebook != null && user.links?.facebook != "null" ) ? user.links?.facebook : "",
            instagram :(user?.links?.instagram != null && user.links?.instagram != "null" ) ? user.links?.instagram : "",
            youtube :(user?.links?.youtube != null && user.links?.youtube != "null" ) ? user.links?.youtube : "",
            flickr : (user?.links?.flickr != null && user.links?.flickr != "null" ) ? user.links?.flickr : "",
        });
    }, [user]);
    const setState = (_state = {}) => {
        _setState({
            ...state,
            ..._state
        });
    };
    const showLinkModal =( currentLink )=>{
        setState({
            modalLink : true,
            current : currentLink,
            contentTempt : state[currentLink]
        });
    };
    const  onHideModal = ()=>{
        setState({
            modalLink : false,
            contentTempt : "",
            current : "",
        });
    };
    const  saveLink = ()=>{
        setState({
            modalLink : false,
            [state.current] : state.contentTempt,
            contentTempt : "",

        });
    };
    const linkLabeLModal ={
        website : "Website",
        facebook: "Facebook",
        instagram : "Instagram",
        youtube : "Youtube",
        flickr : "Flickr"
    };

    const genLinkModal = () => {
        return (
            <Modal show={state.modalLink} onHide={onHideModal} role="document" className="modal-form-link" >
                <Modal.Header closeButton>
                    <h5 className="modal-title">Thêm liên kết {linkLabeLModal[state.current]}</h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="inputLink">
                        <div className="inputLink-form mt-0">
                            <input className="form-control" type="text" placeholder={"Hãy nhập liên kết " + linkLabeLModal[state.current] +" của bạn..."}
                                onChange={(e) =>{
                                    setState({ contentTempt : e.target.value });
                                }}
                                value={state.contentTempt}
                            />
                            <ul className="btn-footer">
                                <li>
                                    <button className="btn btn--redWhite" onClick={ () => { onHideModal();}}>Hủy bỏ</button>
                                </li>
                                <li>
                                    <button className="btn btn--blue" onClick={ () => { saveLink();}}>Lưu</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    };

    return (
        <div>
            <div className="wrap">
                <div className="wrapContent pt-0">
                    <div className="profileInformation">
                        {/* <h2 className="title pc-only">Thông tin hồ sơ</h2> */}
                        <div className="profileAvatar">
                            <div className="profile-thumb wrap-next-image">
                                <img src={avatarTemp} alt="" />
                            </div>
                            <label className="item-pen">
                                <form onSubmit={handleSubmit(onSubmit)} id="avatar-form">
                                    <input {...register('avatar')} className="custom-file-input" accept="image/png, image/jpeg"
                                        type="file"
                                        onChange={changeAvatar}
                                    />
                                    <img src="/images/icon-pen.svg" alt="" />
                                </form>
                            </label>
                        </div>

                        {
                            displayButtonAva &&
                            <div className="text-center" style={{ margin: "10px auto" }}>
                                <button className="btn" onClick={() => deleteAvatar()}>Hủy</button>
                                <button type="submit" className="btn btn--blue" form="avatar-form">Lưu ảnh đại diện</button>
                            </div>
                        }

                        <div className="profileForm">
                            <ul>
                                <li>
                                    <div className="profile-group">
                                        <label className="profile-group-lable">Họ và tên<span className="required">*</span></label>
                                        <div className="profile-group-info">
                                            <input className="form-control" type="text"
                                                onChange={(e) => setUserTemp({ ...userTemp, fullname: e.target.value })}
                                                value={userTemp.fullname} />
                                        </div>
                                    </div>
                                    <div className="profile-group">
                                        <label className="profile-group-lable">Ngày sinh<span className="required">*</span></label>
                                        <div className="profile-group-info">
                                            <input className="form-control" type="date"
                                                onChange={(e) => setUserTemp({ ...userTemp, birthday: e.target.value })}
                                                value={userTemp.birthday} />
                                        </div>
                                    </div>
                                    <div className="profile-group">
                                        <label className="profile-group-lable">Giới tính</label>
                                        <div className="profile-group-info">
                                            <label className="custom-control custom-radio">
                                                <input name="radio" className="custom-control-input" type="radio"
                                                    onChange={() => setUserTemp({ ...userTemp, gender_id: 1 })}
                                                    checked={userTemp.gender_id === 1} />
                                                <span className="custom-control-indicator"></span>
                                                <span className="custom-control-description">Nam</span>
                                            </label>
                                            <label className="custom-control custom-radio">
                                                <input name="radio" className="custom-control-input" type="radio"
                                                    onChange={() => setUserTemp({ ...userTemp, gender_id: 2 })}
                                                    checked={userTemp.gender_id === 2} />
                                                <span className="custom-control-indicator"></span>
                                                <span className="custom-control-description">Nữ</span>
                                            </label>
                                            <label className="custom-control custom-radio">
                                                <input name="radio" className="custom-control-input" type="radio"
                                                    onChange={() => setUserTemp({ ...userTemp, gender_id: 3 })}
                                                    checked={userTemp.gender_id === 3} />
                                                <span className="custom-control-indicator"></span>
                                                <span className="custom-control-description">Khác</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="profile-group">
                                        <label className="profile-group-lable">Điện thoại</label>
                                        <div className="profile-group-info">
                                            <input className="form-control" type="text"
                                                onChange={(e) => setUserTemp({ ...userTemp, phone_number: e.target.value })}
                                                value={userTemp.phone_number} />
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="profile-group">
                                        <label className="profile-group-lable">Email</label>
                                        <div className="profile-group-info">
                                            <input className="form-control" type="text" value={userTemp.email} disabled />
                                        </div>
                                    </div>
                                    <div className="profile-group">
                                        <label className="profile-group-lable">CMND/ CCCD<span className="c-red">*</span></label>
                                        <div className="profile-group-info">
                                            <input className="form-control" type="text" value={userTemp.cmnd_number} onChange={(e) => setUserTemp({ ...userTemp, cmnd_number: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="profile-group">
                                        <label className="profile-group-lable">Địa chỉ<span className="required">*</span></label>
                                        <div className="profile-group-info">
                                            <Select
                                                options={tinhOp}
                                                styles={customStyles}
                                                placeholder={userTemp?.province?.name || "Tỉnh/Thành phố"}
                                                closeMenuOnSelect={true}
                                                hideSelectedOptions={false}
                                                onChange={selecteds => {
                                                    setTinh(xaPhuong.find(x => x.id === selecteds.value));
                                                }}
                                            />
                                        </div>
                                        {!isEmpty(tinh) && <div className="profile-group-info">
                                            <Select
                                                options={quanOp}
                                                styles={customStyles}
                                                placeholder={userTemp?.district?.name || "Quận/huyện"}
                                                closeMenuOnSelect={true}
                                                hideSelectedOptions={false}
                                                onChange={selecteds => {
                                                    setQuan(tinh.districts.data.find(x => x.id === selecteds.value));
                                                }}
                                            />
                                        </div>}
                                        {!isEmpty(quan) && <div className="profile-group-info">
                                            <Select
                                                options={xaOp}
                                                styles={customStyles}
                                                placeholder={userTemp?.ward?.name || "Phố/Xã/Phường"}
                                                closeMenuOnSelect={true}
                                                hideSelectedOptions={false}
                                                onChange={selecteds => {
                                                    setXa(quan.wards.data.find(x => x.id === selecteds.value));
                                                }}
                                            />
                                        </div>}
                                        <div className="profile-group-info">
                                            <input className="form-control" type="text" value={userTemp.address}
                                                onChange={(e) => setUserTemp({ ...userTemp, address: e.target.value })} />
                                        </div>
                                    </div>
                                </li>
                                <li className="w-100">
                                    <div className="profile-group">
                                        <label className="profile-group-lable">Mô tả</label>
                                        <div className="profile-group-info">
                                            <textarea className="form-control"
                                                onChange={(e) => setUserTemp({ ...userTemp, bio: e.target.value })}
                                                value={userTemp.bio}></textarea>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className="profileShare">
                            <label className="profileShare-lable">Liên kết</label>
                            <ul>

                                <li >
                                    <img src="/images/icon-website.svg" alt="" onClick={() => { showLinkModal("website"); }} />
                                </li>
                                <li >
                                    <img src="/images/Facebook.svg" alt="" onClick={() => { showLinkModal("facebook"); }} />
                                </li>
                                <li >
                                    <img src="/images/Instagram.svg" alt="" onClick={() => { showLinkModal("instagram"); }} />
                                </li>
                                <li >
                                    <img src="/images/icon-youtube.svg" alt="" onClick={() => { showLinkModal("youtube"); }} />
                                </li>
                                <li >
                                    <img src="/images/icon-tiktok.svg" alt="" onClick={() => { showLinkModal("flickr"); }} />
                                </li>

                            </ul>
                        </div>
                        {genLinkModal()}

                        <div className="btnSave mt-3">
                            <button type="submit" className="btn btn--blue" onClick={updateUser}>Lưu thay đổi</button>
                        </div>

                        <div className="profileRegister">
                            <div className="profileRegister-text">
                                <p className="qa">Bạn muốn trở thành chuyên gia trên Happynest?</p>
                                <p className="lable">Hãy đăng ký với Happynest để trở thành chuyên gia ngay</p>
                            </div>
                            <div className="profileRegister-btn">
                                {(user?.is_professional === true || user?.is_professional_unverified === true)?
                                    <button className="btn btn--blue-light" onClick={() => { setIsProfessional(true); }} style={{cursor:"initial"}}>Kiểm tra hồ sơ chờ duyệt Chuyên gia</button>:
                                    <button className="btn btn--blue-light" onClick={() => { setIsProfessional(true); }}>Đăng ký ngay</button>
                                }
                            </div>
                        </div>
                    </div>
                </div></div></div>
    );
}
